<template>
  <span
    :class="[
      'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold',
      statusClasses
    ]"
  >
    {{ status }}
  </span>
</template>

<script>
export default {
  name: 'TicketStatusBadge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusClasses() {
      const statusMap = {
        'Open': 'bg-red-600 text-white',
        'Answered': 'bg-green-600 text-white',
        'Customer-Reply': 'bg-yellow-500 text-gray-900',
        'Closed': 'bg-gray-600 text-white',
        'On Hold': 'bg-blue-600 text-white',
        'In Progress': 'bg-purple-600 text-white'
      };
      return statusMap[this.status] || 'bg-gray-600 text-white';
    }
  }
};
</script>
